module.exports = __webpack_public_path__ + "img/product-s618-1000-1.0a4d8952.png";